import { checkScreenBreakPoint } from 'helpers/checkScreenBreakpoint';
import { capitalize } from 'lodash';
import { GenericLabelValue } from 'types/common';
import { isGuestEnv } from 'utils/envUtils';

const SUBCONTRACTOR = `<?xml version="1.0" encoding="UTF-8"?><svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Fill 1</title> <desc>Created with Sketch.</desc> <g id="03-Employees" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="03.05---Employee-View" transform="translate(-224.000000, -275.000000)" fill="#333333"> <path d="M230.011986,285.924124 L230.011986,275.99309 C232.754331,275.99309 234.977503,278.216262 234.977503,280.958607 C234.977503,283.700952 232.754331,285.924124 230.011986,285.924124 M229.958607,274.999986 C226.667848,274.999986 223.999986,277.667848 223.999986,280.958607 C223.999986,284.249503 226.667848,286.917228 229.958607,286.917228 C233.249503,286.917228 235.917228,284.249503 235.917228,280.958607 C235.917228,277.667848 233.249503,274.999986 229.958607,274.999986" id="Fill-1"></path> </g> </g></svg>`;
const QUICKBOOKS_ICON = `<?xml version="1.0" encoding="UTF-8"?><svg width="28px" height="27px" viewBox="0 0 28 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Group 5</title> <desc>Created with Sketch.</desc> <g id="16-Budget-/-Expense" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="16.08---Budget/Expense---Tutorial---1.1" transform="translate(-1217.000000, -518.000000)"> <g id="Group-10" transform="translate(543.000000, 269.000000)"> <g id="Group-5" transform="translate(674.000000, 249.000000)"> <rect id="Rectangle" fill="#333333" fill-rule="nonzero" transform="translate(13.637333, 13.600000) rotate(-90.000000) translate(-13.637333, -13.600000) " x="0.4" y="0" width="26.4746667" height="27.2" rx="13.2373333"></rect> <g id="Group-10" transform="translate(7.200000, 7.200000)" fill="#FFFFFF"> <path d="M11.2592545,7.03425937 C11.0492788,8.09221875 10.2739758,8.89164375 9.2490303,9.0981 C9.09036364,9.13006875 8.9260303,9.14708437 8.7641697,9.14863125 C8.16813939,9.1546125 7.57200606,9.15110625 6.97587273,9.15079687 C6.95093939,9.15079687 6.92590303,9.14821875 6.89447879,9.14646562 L6.89447879,2.25781875 C7.25199394,2.21079375 7.66648485,2.48850937 7.79413939,2.87069062 C7.83277576,2.98619062 7.85111515,3.11375625 7.85142424,3.23585625 C7.8550303,4.82408437 7.85379394,6.4123125 7.85379394,8.00054062 L7.85379394,8.18224687 C8.41026061,8.1505875 8.9658,8.27423437 9.47950909,7.98991875 C10.1369455,7.62578437 10.4614909,6.89431875 10.2784061,6.17729062 C10.0982061,5.47150312 9.46096364,4.97939062 8.71821818,4.97289375 C8.60323636,4.9718625 8.48815152,4.9726875 8.35915758,4.9726875 L8.35915758,4.01001562 C9.0089697,3.96144375 9.6152,4.06869375 10.1615697,4.43685 C11.0108485,5.00929687 11.4535697,6.05519062 11.2592545,7.03425937 L11.2592545,7.03425937 Z M6.16687879,10.8961875 C5.71910909,10.94445 5.25835758,10.5417469 5.2132303,10.0683 C5.20756364,10.0086937 5.20735758,9.94836562 5.20725455,9.88834687 C5.20694545,8.30867812 5.20704848,6.7291125 5.20704848,5.14944375 L5.20704848,4.95030937 C4.77638182,4.97444062 4.35261818,4.94721562 3.95213939,5.03115937 C3.1518,5.19894375 2.64921818,5.96402812 2.74555152,6.77510625 C2.83992727,7.56844687 3.51786667,8.1687375 4.33221818,8.17925625 C4.45142424,8.18080312 4.5706303,8.1794625 4.69818182,8.1794625 L4.69818182,9.14491875 C3.62347273,9.21390937 2.74410909,8.86978125 2.16353333,7.95062812 C1.63663636,7.11624375 1.60706667,6.22679062 2.0729697,5.35765312 C2.53969697,4.48655625 3.29933939,4.03724062 4.28616364,4.00485937 C4.88600606,3.98526562 5.48687879,4.00114687 6.08733939,4.00145625 C6.11196364,4.00145625 6.13658788,4.00506562 6.16687879,4.00754062 L6.16687879,10.8961875 Z M6.54221818,-1.45661261e-13 C2.92904848,-1.45661261e-13 -1.47792889e-12,2.9316375 -1.47792889e-12,6.54812812 C-1.47792889e-12,10.1646187 2.92904848,13.0963594 6.54221818,13.0963594 C10.1552848,13.0963594 13.0844364,10.1646187 13.0844364,6.54812812 C13.0844364,2.9316375 10.1552848,-1.45661261e-13 6.54221818,-1.45661261e-13 L6.54221818,-1.45661261e-13 Z" id="Fill-1"></path> <path d="M12.6319479,11.8747922 L12.7192145,11.8747922 C12.8209055,11.8747922 12.9033297,11.8408641 12.9033297,11.7585703 C12.9033297,11.6857641 12.850063,11.6371922 12.7337418,11.6371922 C12.6853176,11.6371922 12.6512145,11.6421422 12.6319479,11.6470922 L12.6319479,11.8747922 Z M12.6272085,12.3255516 L12.4430933,12.3255516 L12.4430933,11.5305609 C12.5156267,11.5160203 12.6173176,11.5063266 12.7483721,11.5063266 C12.8985903,11.5063266 12.9659721,11.5305609 13.0243903,11.5645922 C13.067663,11.5985203 13.101663,11.6614266 13.101663,11.7389766 C13.101663,11.8262203 13.0337661,11.8940766 12.9372267,11.9233641 L12.9372267,11.9329547 C13.0144994,11.9620359 13.0582873,12.0201984 13.0822933,12.1268297 C13.1067115,12.2480016 13.1209297,12.2964703 13.1406085,12.3255516 L12.9419661,12.3255516 C12.917857,12.2964703 12.9033297,12.2238703 12.8788085,12.1317797 C12.8646933,12.0445359 12.8161661,12.0056578 12.7144752,12.0056578 L12.6272085,12.0056578 L12.6272085,12.3255516 Z M12.1379176,11.9087203 C12.1379176,12.2625422 12.3997176,12.5437641 12.7578509,12.5437641 C13.1067115,12.5437641 13.3631539,12.2625422 13.3631539,11.9136703 C13.3631539,11.5596422 13.1067115,11.2736766 12.7531115,11.2736766 C12.3997176,11.2736766 12.1379176,11.5596422 12.1379176,11.9087203 L12.1379176,11.9087203 Z M13.5665358,11.9087203 C13.5665358,12.3594797 13.2133479,12.7133016 12.7531115,12.7133016 C12.2980267,12.7133016 11.9347418,12.3594797 11.9347418,11.9087203 C11.9347418,11.4676547 12.2980267,11.1138328 12.7531115,11.1138328 C13.2133479,11.1138328 13.5665358,11.4676547 13.5665358,11.9087203 L13.5665358,11.9087203 Z" id="Fill-4"></path> </g> </g> </g> </g> </g></svg>`;
const ONLINE_PAYMENT_ICON = `<svg width="14" height="12" class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 11" xmlns:xlink="http://www.w3.org/1999/xlink" id=""><g id="Invoices" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="14.0.1.0-Invoices-/-View-Payement-Requested" transform="translate(-1689.000000, -324.000000)" fill="#333" fill-rule="nonzero"><g id="Group-8" transform="translate(1565.000000, 119.000000)"><g id="Asset-16" transform="translate(124.000000, 205.000000)"><path d="M18,7.942 L18,9.64839209 C18,10.3948645 17.3948645,11 16.6483921,11 L1.35205924,11 C0.605586806,11 0.000451332634,10.3948645 0.000451332634,9.64839209 L0,7.942 L18,7.942 Z M16.6483921,0 C17.3948645,8.4919843e-17 18,0.605135473 18,1.35160791 L18,6.847 L0,6.847 L0.000451332634,1.35160791 C0.000451332634,0.605135473 0.605586806,3.59169367e-16 1.35205924,0 L16.6483921,0 Z M15.5695312,1.75874054 L13.1285116,1.75874054 C12.8587168,1.75874054 12.640005,1.97745239 12.640005,2.24724713 L12.640005,2.24724713 L12.640005,3.45628998 C12.640005,3.72608472 12.8587168,3.94479657 13.1285116,3.94479657 L13.1285116,3.94479657 L15.5695312,3.94479657 C15.8393259,3.94479657 16.0580377,3.72608472 16.0580377,3.45628998 L16.0580377,3.45628998 L16.0580377,2.24724713 C16.0580377,1.97745239 15.8393259,1.75874054 15.5695312,1.75874054 L15.5695312,1.75874054 Z" id="Combined-Shape"></path></g></g></g></g></svg>`;
const QB_ICON = `<svg width="14" height="12" class="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" xmlns:xlink="http://www.w3.org/1999/xlink" id=""><g id="Invoices" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="14.0.1.1-Invoices-/-View-Sent-to-Customer-QB" transform="translate(-1688.000000, -323.000000)" fill="#333"><g id="Group-8" transform="translate(1565.000000, 119.000000)"><g transform="translate(123.000000, 204.000000)"><path d="M12.1853404,7.46057813 C11.9580939,8.58265625 11.1190214,9.43053125 10.0097731,9.6495 C9.83805588,9.68340625 9.66020596,9.70145313 9.48503214,9.70309375 C8.8399777,9.7094375 8.19481175,9.70571875 7.54964581,9.70539063 C7.52266168,9.70539063 7.49556605,9.70265625 7.46155713,9.70079688 L7.46155713,2.39465625 C7.84847829,2.34478125 8.29706152,2.63932813 8.43521579,3.04467188 C8.47703004,3.16717188 8.49687787,3.30246875 8.49721238,3.43196875 C8.50111505,5.11645313 8.49977699,6.8009375 8.49977699,8.48542188 L8.49977699,8.67814063 C9.10201364,8.6445625 9.70324675,8.77570313 10.259209,8.47415625 C10.9707202,8.08795313 11.3219599,7.31215625 11.1238161,6.55167188 C10.9287944,5.80310938 10.2391381,5.28117188 9.43530106,5.27428125 C9.31086187,5.2731875 9.18631116,5.2740625 9.04670733,5.2740625 L9.04670733,4.25304688 C9.7499672,4.20153125 10.4060606,4.31528125 10.9973698,4.70575 C11.9165027,5.31289063 12.3956382,6.42217188 12.1853404,7.46057813 L12.1853404,7.46057813 Z M6.67411124,11.5565625 C6.189512,11.60775 5.69086318,11.1806406 5.64202414,10.6785 C5.63589138,10.6152813 5.63566837,10.5512969 5.63555687,10.4876406 C5.63522235,8.81223438 5.63533386,7.1369375 5.63533386,5.46153125 L5.63533386,5.25032813 C5.16924439,5.27592188 4.71062574,5.24704688 4.27720714,5.33607813 C3.41103896,5.51403125 2.86711924,6.32548438 2.9713761,7.18571875 C3.07351436,8.02714063 3.80721501,8.6638125 4.68854782,8.67496875 C4.8175587,8.67660938 4.94656959,8.6751875 5.08461236,8.6751875 L5.08461236,9.69915625 C3.92150728,9.77232813 2.96981503,9.40734375 2.34148629,8.43248438 C1.77125148,7.54753125 1.73924964,6.60417188 2.2434737,5.68235938 C2.74858979,4.75846875 3.57071363,4.28192188 4.63870523,4.24757813 C5.28788535,4.22679688 5.93818051,4.24364063 6.58802965,4.24396875 C6.61467926,4.24396875 6.64132887,4.24779688 6.67411124,4.25042188 L6.67411124,11.5565625 Z M7.08032271,0 C3.16996589,0 0,3.1093125 0,6.94498438 C0,10.7806563 3.16996589,13.8900781 7.08032271,13.8900781 C10.990568,13.8900781 14.1606454,10.7806563 14.1606454,6.94498438 C14.1606454,3.1093125 10.990568,0 7.08032271,0 L7.08032271,0 Z" id="Fill-1"></path><path d="M13.7727076,12.8990909 L13.8873054,12.8990909 C14.020845,12.8990909 14.1290838,12.8545455 14.1290838,12.746499 C14.1290838,12.6509091 14.0591345,12.5871373 13.9063825,12.5871373 C13.8427922,12.5871373 13.7980084,12.5936364 13.7727076,12.6001354 L13.7727076,12.8990909 Z M13.7664839,13.4909091 L13.5247055,13.4909091 L13.5247055,12.4471373 C13.6199556,12.4280464 13.7534952,12.4153191 13.9255949,12.4153191 C14.12286,12.4153191 14.2113452,12.4471373 14.2880595,12.4918182 C14.3448848,12.5363636 14.3895333,12.6189555 14.3895333,12.7207737 C14.3895333,12.8353191 14.3003716,12.9244101 14.173597,12.9628627 L14.173597,12.9754545 C14.2750708,13.0136364 14.3325727,13.09 14.3640972,13.23 C14.3961629,13.3890909 14.4148341,13.4527273 14.4406761,13.4909091 L14.1798207,13.4909091 C14.1481608,13.4527273 14.1290838,13.3574081 14.0968827,13.236499 C14.0783468,13.1219536 14.0146213,13.0709091 13.8810817,13.0709091 L13.7664839,13.0709091 L13.7664839,13.4909091 Z M13.1239514,12.9436364 C13.1239514,13.4081818 13.4677448,13.7774081 13.9380423,13.7774081 C14.3961629,13.7774081 14.7329208,13.4081818 14.7329208,12.9501354 C14.7329208,12.4853191 14.3961629,12.1098646 13.9318186,12.1098646 C13.4677448,12.1098646 13.1239514,12.4853191 13.1239514,12.9436364 L13.1239514,12.9436364 Z M15,12.9436364 C15,13.5354545 14.5361969,14 13.9318186,14 C13.3342053,14 12.8571429,13.5354545 12.8571429,12.9436364 C12.8571429,12.3645455 13.3342053,11.9 13.9318186,11.9 C14.5361969,11.9 15,12.3645455 15,12.9436364 L15,12.9436364 Z" id="Fill-4"></path></g></g></g></g></svg>`;

export const JOB_TYPES = [
  'All',
  'Started',
  'Completed',
  'Scheduled',
  'Unscheduled',
  'Skipped',
  'Paused'
];

// export const CUSTOMER_TYPES = [ < div > All Customers < /div>, 'Residential', 'Commercial', 'Hide Customers'];
export const CUSTOMER_TYPES = [
  {
    label: 'All Customers',
    icon: 'customer.png'
  },
  {
    label: 'Residential',
    icon: 'resident.png'
  },
  {
    label: 'Commercial',
    icon: 'commercial.png'
  }
];
// limit dropdown values
export const LIMIT_OPTIONS = [
  {
    label: '10 rows',
    value: 10
  },
  {
    label: '20 rows',
    value: 20
  },
  {
    label: '30 rows',
    value: 30
  },
  {
    label: '40 rows',
    value: 40
  },
  {
    label: '50 rows',
    value: 50
  }
];

const hasBreakpointOccured = checkScreenBreakPoint();
export const APP_TOUR = [
  {
    title: 'Welcome to Horizon360!',
    intro:
      '<p>Let’s take a quick tour of the site. You can restart this Tutorial at any time by clicking your profile icon in the top right corner and pressing Restart Tutorial.</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-profile-tut',
    title: 'Profile',
    intro:
      '<p>Click here for your profile options where you can edit account settings, view help content, and contact us for additional support or feedback.</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-tutorial',
    title: 'Page Overview',
    intro: '<p>Each page has a quick Overview showing you how to use it and get started.</p>',
    position: 'right'
  },
  {
    element: hasBreakpointOccured
      ? undefined
      : '.left-sidebar-container .js-sidebar-quickbooks-tut',
    title: 'QuickBooks Online Sync',
    intro:
      '<p>From the finances tab, you will be able to sync Horizon360 with a QuickBooks Online account (if using QBO), manage, edit and send invoices to your customers, create and maintain a budget (requires syncing to QBO) and access financial analytics for your crews, customers and routes.</p>',
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.left-sidebar-container .js-leftsidebar-tut',
    title: 'Site Navigation',
    intro:
      '<p>Go to a page and click the Page Overview icon to learn about the page and how it works.</p>',
    position: 'right'
  }
];
export const QUICKBOOKS_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'QuickBooks Page',
    intro:
      '<p>Use the QuickBooks page to sync Horizon360 to QuickBooks.  The first time you do this you will need to have your QB login credentials handy.  Horizon will sync your customers, employees services and expenses.  </p>',
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'QuickBooks Page',
    intro:
      '<p>You’ll save a lot of time setting up Horizon360 when you sync. Before you do, please make sure your data is clean in QB; Horizon360 will pull it in as it exists in QB.</p>',
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-quickbooks-nav-tut',
    title: 'Employees, Customers, Services, Expenses',
    intro:
      '<p>Click here to select a tab.  Note:  your expenses will also be populated in the budgeting area on Company page</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-sync-direction-tut',
    title: 'Sync Direction',
    intro:
      '<p>Choose whether to sync from QuickBooks and match to Horizon360, or you can go from Horizon360 to QuickBooks.</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.create-skip-dd-wrapper',
    title: 'Create, Skip, or Search',
    intro:
      '<p>After you’ve pulled your data in, you will use a drop down for each line item to create or skip, and align the data with QuickBooks</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-sync-now-btn-tut',
    title: 'Save',
    intro:
      '<p>Click <i>Save</i> to save your changes and you’re done! Please allow 15 minutes for changes made in Horizon360 or QuickBooks to be reflected in either system.</p>',
    position: 'bottom'
  }
];

export const SCHEDULE_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Schedule Page',
    intro: `<p>Schedule jobs, on-demand jobs and routes by dragging them to the calendar with your mouse. Crews will be notified of their scheduled jobs and the jobs will be listed in the Mobile App for each crew.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-schedule-controls-tut',
    title: 'Filters',
    intro: `<p>Control how you use your schedule:</p>
      <ul style="list-style-type: disc; padding-left: 20px; text-align: left;">
        <li style="list-style-type: disc;">Customize your calendar view</li>
        <li style="list-style-type: disc;">Filter for specific Crew(s)</li>
        <li style="list-style-type: disc;">When only one crew is selected from the dropdown. Dragging an Unscheduled job onto the schedule to automatically assign it to that crew.</li>
        <li style="list-style-type: disc;">The Show Details toggle lets you control how much information gets displayed on the schedule page</li>
      </ul>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-joblist-tut',
    title: 'Job List',
    intro: `<p>The right pane lists your jobs for the week categorized by status. Selecting a crew from the dropdown before dragging an Unscheduled job to the schedule screen will automatically assign that job to the selected crew.</p>
      <p>Crew Leads will be notified from their Horizon360&reg; Mobile App when a new job is scheduled for their crew.</p>`,
    position: 'left'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-addjob-tut',
    title: 'Create Job',
    intro: `<p>Click Add Job to create a Job on the schedule page. For more detail on how to create Jobs, see the <a href="https://web-support-horizon360.toro.com/articles/jobs" target="_blank" rel="noopener noreferrer">Jobs User Guide</a> in the Help section.</p>`,
    position: 'bottom'
  },
  {
    title: 'Move Jobs',
    intro: `<p>To move a single job, drag the job on the schedule to another date. To move multiple jobs, you can hold the Shift key while clicking to select jobs on the schedule and then select the Move option from the Action menu in the upper right on the screen. The selected jobs will be moved to the selected date.</p>`,
    position: 'auto'
  }
];

export const EMPLOYEE_CREW_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Employees and Crews Page',
    intro: `<p>Use the Employees and Crews page to add employees, give them access to the mobile app, and assign them to crews.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-employee-tut',
    title: 'Add Employee',
    intro: `<p>When you add an employee, you can give them access to the mobile app and/or give them administrative  rights to the software.  Horizon360 assumes that you will only give crew leads access to the mobile app.  If you give an employee admin rights to the software, they will have access to your data and activity.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-employee-tut',
    title: 'Add Employee',
    intro: `<p>The software will prompt you to enter employees’ salary or hourly pay rate.  This information will be used to track your direct labor costs.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-employee-tut',
    title: 'Add Subcontractor',
    intro: `<p>You will also be able to add subcontractors. Subcontractors cannot have access to the desktop software, but you can give them mobile app access.</p>
      <p>A subcontractor will be designated by this icon: ${SUBCONTRACTOR}</p>`,
    position: 'bottom'
  },

  {
    element: hasBreakpointOccured ? undefined : '.js-add-crew-tut',
    title: 'Add Crew',
    intro: `<p><b>Crews</b> are a collection of employees and equipment that complete jobs.
    You will need to build crew(s), even if you only have one employee. From the schedule screen, you will assign work to crews, not employees.</p>

    <p><b>Crew Leads:</b> For their Crew - they can update equipment and employee assignments.</p>

    <p><b>Crew Leads with Full Tracking Access:</b> For all Crews - they can update equipment and employee assignments as well as view other crew's location on the mobile tracking page.</p>

    <p style="margin-bottom: 0;"><b>Tier based limitations:</b></p>
    <ul style="list-style-type: none; margin: 0; padding: 0;">
      <li>Essential & Basic:  Max: 1 Crew</li>
      <li>Premium:  Max: 5 Crews</li>
      <li>Unlimited:  unlimited crews</li>
    </ul>
    `,
    position: 'bottom'
  }
];

export const EQUIPMENT_DEVICE_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Equipment and Device Page',
    intro: `<p>Use the Equipment page to add, review, or update equipment. With the Premium and Unlimited tiers, devices such as EquipTrack and DriveTrack track equipment location and usage, and automatically start a job when they enter a geofence.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-equipment-tut',
    title: 'Add Equipment',
    intro: `<p>Add equipment and assign it to a crew. As your equipment changes crews, your employees can update which equipment they have for the day via the mobile app.</p>`,
    position: 'bottom'
  },
  !isGuestEnv()
    ? {
        element: hasBreakpointOccured ? undefined : '.js-buy-device-btn',
        title: 'Buy Device',
        intro: `<p>Learn about the device options, what they track and how they are used. Determine what devices will work for your operation and subscribe to the ones you want.</p>`,
        position: 'bottom'
      }
    : '',
  {
    element: hasBreakpointOccured ? undefined : '.js-add-device-tut',
    title: 'Add Device',
    intro: `<p>After you have installed a device on a piece of equipment, pair the device and equipment in the software.  Horizon360 will track the activity of the equipment and the crew associated with the equipment.</p>`,
    position: 'bottom'
  }
];

// DEMO (revert after screenshot): showcases the intro.js Hint feature on the Equipment page.
export const EQUIPMENT_HINTS = [
  {
    element: '.jobFilter',
    hint: 'Tip: Filter by type.',
    hintPosition: 'middle-right'
  }
];

export const getMaintenanceTour = ({ hasTasks }: { hasTasks: boolean }) => [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Maintenance Page',
    intro: `<p>Use the Maintenance page to manage all of the maintenance tasks for your equipment and vehicles. You will need to start by setting up Maintenance Tasks in Settings <link to Maintenance Settings>. Once you have created Maintenance Tasks, you can assign these tasks to your various equipment. Maintenance Tasks can be assigned to one or more employees and managed via the desktop and/or the mobile app. Maintenance Tasks assigned to equipment with Horizon360 tracking devices will automatically update when due based on the usage hours.</p>
      <p>Maintenance Tasks assigned to equipment without tracking devices will require manually keeping track of usage hours to complete maintenance tasks as needed.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-assign-maintenance',
    title: 'Assign Maintenance Task',
    intro: `<p>Click Assign Maintenance Task to assign a task to one or more pieces of equipment. You will be prompted to select one of the Maintenance Task Templates you previously created in Settings. You can then adjust the following:
      <ol type='1'>
         <li>Frequency – One Time or Recurring</li>
         <li>Recurring Schedule – How often does this task need to be done (i.e. every 100 hours) & when the first occurrence should happen</li>
         <li>Assigned To – Employee(s) responsible for completing this task</li>
         <li>Description – Include any important details needed for this task (i.e. part numbers)</li>
         <li>Estimated Cost – How much you estimate this task to cost you</li>
         <li>Current Hours – Current Hours your machine has (Note: If you are using H360 tracking, current hours will be pulled automatically based on device readings)</li>
      </ol>
      </p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-filters-maintenance',
    title: 'Filters',
    intro:
      '<p>Use the various filters to narrow down the list of Maintenance tasks by Equipment, Task Type, Employee and/or Task Status.</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured || !hasTasks ? undefined : '.js-manage-maintenance',
    title: 'Manage Maintenance Task',
    intro: `<p>You can manage your maintenance tasks here on the desktop or from the Horizon360 mobile app. Overdue tasks appear at the top of the list, followed by all upcoming tasks. For each task, whether it’s a single occurrence or part of a recurring series, you can take the following actions:</p>
      <p><b>Edit</b><br/>Make changes to the task details, including frequency, cost, assigned employee(s), or current machine hours or mileage. Updates can apply to just this instance or to the entire maintenance series.</p>
      <p><b>Complete</b><br/>Mark this instance as complete. Horizon360 will automatically generate the next task in the series based on the set frequency.<br/><i>Example:</i> If a task repeats every 100 hours and you complete it at 100 hours, the next task will be scheduled for 200 hours.</p>
      <p><b>Mark as Skipped</b><br/>Skip this instance without completing it. The system will generate the next upcoming task based on the same frequency.<br/><i>Example:</i> If a task repeats every 50 hours and is skipped at 100 hours, the next task will be due at 150 hours.</p>
      <p><b>Delete</b><br/>Delete this maintenance task. If it’s part of a recurring series, the next task will still be created based on today’s information and the set frequency.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-export-maintenance',
    title: 'Export Maintenance Task',
    intro:
      '<p>Use the Export CSV to export a list of your maintenance tasks to an Excel spreadsheet. Note that any filters applied will be reflected in the export (i.e. if you filter for Overdue tasks, your export will only include tasks which have an Overdue status, and no Upcoming tasks will be included in the export).</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-buy-maintenance',
    title: 'Buy Parts',
    intro:
      '<p>Need maintenance or replacement parts?  Purchase parts for any of your equipment from your local authorized dealer or through this exclusive Horizon360 Parts Store</p>',
    position: 'bottom'
  }
];

export const ROUTES_ODJS_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Routes Page',
    intro: `<p>Use the Routes page to create a series of jobs that occur in the same order on the same date. Whether you want to create a route for standard weekly mowing jobs or on-demand work (i.e. snow), the Route tool has you covered.  Routes allow you to add jobs with similar services to a "route" to be completed in a specific order. When you schedule a route, all of the jobs will be added to the calendar, saving you time from manually scheduling individual jobs. You can manually select the route order, or the Unlimited plan offers an "Optimize Route" feature that will route the jobs for you based on your choice of shortest distance or shortest time.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-route-tut',
    title: 'Adding a Route',
    intro: `<p>Click on the Add Route button to assign jobs you've created to a route. When creating the route, use the Service & Service Window filters to narrow down your list of jobs. All applicable jobs will be displayed in a list as well as pins on the map. To manually build your route, select jobs from the list or map in the specific order you would like those jobs completed. You can also take away the guess work and utilize "Optimize Route" to have H360 order the jobs based on shortest distance traveled or shortest time traveling. You can edit & adjust your routes any time you like, but any edits made to Optimized Routes will require you to re-optimize the route. </p>`,
    position: 'bottom'
  }
];

export const CUSTOMER_JOB_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Customer and Jobs Page',
    intro: `<p>Use the Customers and Jobs page to create Customers, Contracts and Jobs. You can also import your Customers from QuickBooks by clicking on the QuickBooks icon in the bottom left and keep them in sync.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-customer-tut',
    title: 'Add Customer',
    intro: `<p>Add a Customer, service location(s) and create contracts or jobs. Create Contracts when you have multiple services and jobs for a customer that you will want to invoice in equal payments over the life of the Contract or across the service window.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-customer-tut',
    title: 'Add Customer',
    intro: `<p>When creating a Contract, add jobs and services. Click Save, if you think you’ll need to add jobs or services later. If the Contract is 100% complete and no additional changes will be made, click Save as Unscheduled Job(s). Once you’ve clicked Save as Unscheduled Job(s), you can no longer edit the Contract.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-job-tut',
    title: 'Add Job',
    intro: `<p>Jobs can be one-time or recurring. A Job created outside of a contract will be invoiced individually. A job scheduled within a Contract will be invoiced as defined within the contract.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-job-tut',
    title: 'Add Job',
    intro: `<p>Once the jobs have been created, they will display on the job board on the right side of the Schedule screen under Unscheduled Jobs.  From here they can be scheduled.  Once jobs have been created for your customers, Horizon360 will track and display all instances of the work, be they one-time jobs or recurring work.</p>`,
    position: 'bottom'
  }
];
export const TRACKING_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Tracking Page',
    intro: `<p>Use the Tracking page to see the GPS and usage history of your equipment/vehicles/crews for a particular date or time window.</p>
      <p>H360's Dashboard displays additional device-based analytics.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Tracking Page',
    intro: `<p>You can also see your customers, jobs and current crew location via a tracking device or a crew lead’s mobile device. Crews will need to "clock in" for you to see their location and "clock out" at the end of the day to stop seeing their location (mobile phone only).</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-tracking-filter-tut',
    title: 'Filters',
    intro: `<p>The tracking screen will always default to the current day.  Click on the filters.  Click on the filter dropdowns to select the date, time, crew or asset that you want to track.</p>`,
    position: 'bottom'
  }
];
export const ANALYTICS_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Analytics Page',
    intro: `<p>Use the analytics page to get detailed information on how your crews spend their time, how your equipment is used, profitability by customer or crew.  Make sure to use the filters at the top to get the view you want.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-analytics-tracking-tut',
    title: 'Tracking',
    intro: `<p>The tracking tab allows you to view visual tracking information from the tracking screen in a summarized fashion.  The data source for this data comes from your tracking devices or a crews mobile device.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-analytics-financial-tut',
    title: 'Financial',
    intro: `<p>Analyze your financial picture starting with the revenue you take in less your direct labor expense and your overhead costs.  This tab requires that you complete the Budget/Expense section located in the Company tab on the left navigation bar.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-analytics-productivity-tut',
    title: 'Productivity',
    intro: `<p>Analyze the productivity of the assets that you deploy; including crews, equipment and vehicles.  You can develop benchmarks and compare how your crews compare to each other or benchmarks. </p>`,
    position: 'left'
  }
];

export const getInvoiceTour = ({ isCanadianCompany }: { isCanadianCompany: boolean }) => [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Invoices Page',
    intro: `<p>Use the Invoices page to manage all of your invoicing. You can review and edit invoices before sending them to your customers. We offer three options for you to invoice:</p>
      <ol type='1'>
      <li>Send invoices to QuickBooks® Online</li>
      <li>Send invoices through Horizon360® Online Payments (U.S. Only)</li>
      <li>Mark invoices as manually paid</li>
      </ol>
      ${
        isCanadianCompany
          ? ''
          : "<p>Learn more & enable invoicing with Horizon360 in <a href='/dashboard/settings/online-payment'>Online Payment Settings</a>.</p>"
      }`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-invoice-scroll',
    title: 'Reviewing Invoices',
    intro: `<p>All invoices will be listed according to their due date.  You can view job notes, view proof of service photos, and edit service(s).  Jobs that have a billing method of <b>Standard</b> will be invoiced with the frequency you've defined in settings.  The default setting is to invoice on job completion.  Jobs that have a billing method of <b>Fixed Monthly Average</b> will be invoiced once a month and include all jobs from the month.</p>
      <h3><b>Standard Billing</b></h3>
      <ul class="list-style-disc">
        <li>
          Invoice Frequency options:
          <ul class="list-style-disc">
            <li>Invoice on each job's completion</li>
            <li>Weekly</li>
            <li>Bi-weekly</li>
            <li>Monthly</li>
            <li>Quarterly</li>
          </ul>
        </li>
        <li>Invoice Frequency can be set at a global level and updated for each individual customer and job.</li>
        <li>Utilizes Flat or Variable Rate Pricing</li>
        <li>Customers will be invoiced for completed jobs only</li>
      </ul>

      <h3><b>Fixed Monthly Average (FMA)</b></h3>
      <ul class="list-style-disc">
        <li>Monthly billing over a specified time period</li>
        <li>Options Include:
          <ul class="list-style-disc">
            <li><b>Pre-Billing:</b> Invoices are generated at the start of each month for the specified time period</li>
            <li><b>Post-Billing:</b> Invoices are generated at the end of each month for the specified time period</li>
          </ul>
        </li>
        <li>Limited to Flat Rate Service Pricing</li>
        <li>Invoiced Amount is divided equally among the invoices generated for the specified time period</li>
        <li>Customers will be invoiced for all planned work, regardless of completion status</li>
      </ul>
      `,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-invoices-filters-tut',
    title: 'Filters',
    intro: `<p>Use the various filters to narrow down your list of invoices. You can filter by date range, customer, and invoice status.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-invoices-approve-btn',
    title: 'Sending Invoices',
    intro: `<p>After you have reviewed the invoice, check the boxes next to the invoice(s) you wish to send. You have a few options to send invoices:</p>
      <ol type='1'>
        <li>Send to Invoicing ${QB_ICON} - Sends the invoice to QuickBooks® Online for you to then manually send to your customer through QuickBooks Online</li>
        <li>Request Payment ${QB_ICON} - Sends the invoice to your customer via QuickBooks® Online</li>
        <li>Request Online Payment  (U.S. Only) ${ONLINE_PAYMENT_ICON} - Sends the invoice to your customers with a direct link to pay their invoice online via credit card or ACH</li>
        <li>Combine Invoices - merges multiple invoices into one</li>
      </ol>
      `,
    position: 'left'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-invoices-archive-export-tut',
    title: 'Archive & Export',
    intro: `<p>Use Archive for any invoices you do not need to complete/bill. Use Export to download your invoices to an Excel spreadsheet.</p>`
  }
];

export const ESTIMATES_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-estimates-tut',
    title: 'Estimates Page',
    intro:
      '<p>Use the Estimates page to view a satellite or street level view of a property.  You can draw boundaries around the property to measure square footage and calculate your costs.  You can exclude areas from the estimate, drop in notes, take pictures from a tablet while in the field, and print a PDF of the location</p>',
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-estimates-tut',
    title: 'Estimates Page',
    intro: '<p>You can create estimates for either leads or existing customers. </p>',
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add-estimate-tut',
    title: 'Add Estimate',
    intro: '<p>Click here to get started with a new estimate and search for an address</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-estimate-approve-btn',
    title: 'Approve or Decline',
    intro:
      '<p>You can select a pending estimate and mark it as approved and move it to the approved tab.  From the approved tab, you can convert the estimate into a new job or a new customer or both.</p>',
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-estimate-tabs-tut',
    title: 'Pending, Approved, and Declined',
    intro:
      '<p>Use the tabs to navigate your way around pending, approved or declined estimates</p>',
    position: 'bottom'
  }
];

export const BUDGETING_TOUR = [
  {
    title: 'Budgeting & Expense',
    intro: `<p>The budgeting and expense function captures your business expenses from QuickBooks and helps you understand how you are tracking to your budget.  Don’t have a budget?  Horizon will help you create one.  You can make this as simple or as detailed as you want during set up.<p>

    <p>Horizon360 will calculate your overhead costs and apply these costs to the actual work that your business does; allowing you to understand the true costs to operate your business and apply the overhead costs to the jobs that you do.  One outcome will be an understanding of the minimum amount you must charge, on an hourly basis, to be certain you are recouping your direct and overhead costs (plus margin) for all of the work you do.</p>

    <p>To get started with budgeting, you will first need to connect Horizon360 to your QuickBooks online account and then match your expenses from QuickBooks to an expense category for Horizon360 to track.</p>

    <p>This process first starts by clicking on the QB icon ( ${QUICKBOOKS_ICON} ) at the bottom of your screen and syncing your Horizon360 account with your QuickBooks Online account. This initial set up will take roughly an hour, but afterwards takes only a few minutes each month to maintain and sync new expenses.</p>

    <p>Tip for this page:  Horizon360 will always default to the current year, so make sure to use the date dropdowns if you want to see a different data range.</p>

    `,
    tooltipClass: 'initial-tut-budgeting'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-budgeting-expense-tut',
    title: 'Overall Expense',
    intro: `<p>The % of the total of each of the expense categories you’ve imported from QuickBooks.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-budgeting-overhead-tut',
    title: 'Budgeted and Actual Expense',
    intro: `<p>The % of your expenses broken down into overhead, direct or other expense based on how you classified them in the budget section.  You can toggle between actual and budgeted.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-budgeting-workHours-tut',
    title: 'Budgeted and Actual Work Hours',
    intro: `<p>The total YTD labor hours worked.  You can toggle between the actual labor hours worked or the planned/budgeted labor hours worked.  The expense per hour is the actual or planned expense based on the wages of the employees who have worked.</p>`,
    position: 'left'
  }
];

export const TIMESHEET_REPORT_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Time Sheet Report',
    intro: `<p>This section will allow you to view how an employee’s time is spent within a given time period.  The data is displayed graphically and in table format.  Note, you are only able to view one employee at a time.</p>
          <p>For more detail on how to set up Timesheets, go to the Timesheets Users Guide in the Help section.</p>
          `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-report-filters',
    title: 'Filters',
    intro: `<p>Use the filters to select a date range and the employee that you would like to view.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-employee-tracking-hrs',
    title: 'Employee Tracking (by Hours)',
    intro: `<p>This section will break out the employee's time as a percentage of the day spent working or on breaks.  You can configure if breaks are paid or unpaid in Settings.</p>`
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-employee-tracking',
    title: 'Employee Tracking',
    intro: `<p>A graphical display of the selected employee’s time for each day selected in the date range filter.</p>
     `
  },
  {
    title: 'Scroll Bar',
    intro: `<p>Use the scroll bar on the right hand side of your screen or your mouse roller to navigate down the page.  Note that some sections on this page may also have their own scroll bar.</p>
     `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-report-table',
    title: 'Timesheet',
    intro: `<p>A daily itemized list of employee’s time for the selected date range.</p>`
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-export-csv',
    title: 'Export CSV',
    intro: `<p>Export the timesheet details of the selected employee to a CSV (Excel) file.</p>
     `
  }
];

export const EMPLOYEE_TIMESHEET_LIST = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Employee Timesheet',
    intro: `<p>Use this page to review, edit and approve an employee(s) timesheet(s).  Approved Timesheet(s) can be downloaded.</p>
    <p>For more detail on how to set up Timesheets, go to the Timesheets Users Guide in the Help section.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-list-filters',
    title: 'Filters',
    intro: `<p>Use the filters to select a date range, a crew, an individual employee and/or timesheet status.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-sorting-icon',
    title: 'Sorting',
    intro: `<p>Use the up/down arrows (where available) to sort the list of the displayed timesheets.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-list-pending',
    title: 'Pending',
    intro: `<p>This tab will show the timesheet(s) that are available for you to approve.  From here you can review and edit a timesheet.  To approve a timesheet, click the check box next to the line(s) you want to approve, then click the approve button at the top of the screen.  To edit a timesheet, click the “pencil” icon on the line you want to edit.</p>`
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-list-approved',
    title: 'Approved',
    intro: `<p>This tab shows all of the timesheets you have approved. From here, you can Download the Timesheet Report for you to easily upload to your payroll system.</p>
    `
  }
  // {
  //   element:hasBreakpointOccured ? undefined :  '.js-list-quickbooks',
  //   title: 'Quickbooks',
  //   intro: `<p>This tab contains all the timesheets sent to QuickBooks.</p>
  //   `
  // }
];

export const JOB_REPORTING_TUTORIAL = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Job Reporting',
    intro: `<p>Use the Job Reporting page to search for any job(s) you have created. You can filter by Job status (Unscheduled, Scheduled, Skipped, Completed, etc.), Job Type (standard, on-demand, etc.), Crew, Customer, Service, Equipment, or Material assigned to the job. Reviewing your Job Reporting page on a regular basis will help ensure you don’t miss any promised work.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-tabs-tut',
    title: 'Scheduled vs Unscheduled Jobs',
    intro: `<p>You can run the Job Reporting for all Scheduled jobs or all Unscheduled jobs. Since Unscheduled jobs do not yet have any Scheduled/Skipped/Reschedule/Completed date, these jobs are reported separate from Scheduled Jobs.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-rightsidebar-tut',
    title: 'Filters',
    intro: `<p>Use the Filters to narrow down your list of jobs by Status, Type, Crew, Customer, Services and/or Equipment. Scheduled Jobs will allow you to pull through all jobs that have been Scheduled, Started, Completed, Skipped, Reschedule or Paused. Note that Unscheduled jobs cannot be filtered by Status, Crew or Equipment, as those filters only apply once a job has been added to the schedule.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.RangeExample',
    title: 'Date',
    intro: `<p>Use the Date filter to search for jobs within a certain date range. Note that Scheduled Jobs will apply the Date filter to the job’s Scheduled date. Unscheduled jobs will apply the Date filter to the job’s Service Window date. Started, Skipped, Rescheduled, and Completed Jobs will apply the Date filter to the job’s Started, Skipped, Rescheduled, or Completed date.</p>
    `
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-create-job',
    title: 'Create Job',
    intro: `<p>Click Add Job to create a Job on the schedule page. For more detail on how to create Jobs, see the
    <a href='https://web-support-horizon360.toro.com/articles/jobs' target='_blank' rel='noopener noreferrer'>Jobs User Guide</a> in the Help section.</p>
    `
  }
];

export const CUSTOMERS_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Customers Page',
    intro: `<p>Use the Customers page to view and manage all of your Customers. You can add new clients and edit existing ones and use various filters to narrow down your list. You can import your customers from QuickBooks Online, Excel spreadsheet or add them individually. With CRM, you can quickly send emails to your customers as well.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-customerlist',
    title: 'Customer List',
    intro: `<p>Your list of Customers will display their Name, City (Service Address), Email Address, Phone Number and Active Status. Use the quick-action buttons to view a specific customer’s analytics, view/edit their details and delete if needed.</p>
      <p>Tap the View/Edit icon to go into a customer’s profile and manage their Locations, Jobs, Estimates, Email Communications & Files. Tap anywhere on the customer line to see a snapshot of their info on the right.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-filters-search-tut',
    title: 'Filters and Search',
    intro: `<p>Use the filters to narrow down your list of jobs by Status, Type, City and/or Service(s) provided. You can also search for a specific customer by name, email address, phone number or address.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-addcustomer',
    title: 'Add New',
    intro: `<p>Use the Add drop-down to quickly add a new Customer, Job, or Estimate for the current customer selected.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-sendemail',
    title: 'Send Email',
    intro: `<p>Check the box at the top-left of your customer list and click Send Email to send an email to these customers. CRM is included with the Premium and Unlimited tiers.</p><p>Note: AI tools are only available at the Unlimited level.</p>`,
    position: 'bottom'
  }
];

export const CUSTOMER_DETAILS_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-customer-information-tut',
    title: 'Customer Information',
    intro: `<p>The customer’s contact information, service locations and billing information will be listed on the right-side, along with the ability to activate/deactivate or edit their information.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-locations',
    title: 'Locations',
    intro: `<p>The Locations tab will list the customer’s Billing and Service Locations. Add, edit, and delete locations as needed.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-jobs',
    title: 'Jobs',
    intro: `<p>All jobs for this customer appear in the Jobs tab. You can clone existing jobs or add, edit, and delete jobs as needed. Filters help you narrow by date, job status, job type, or assigned services.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-estimates',
    title: 'Estimates',
    intro: `<p>The Estimates tab will hold all of the estimates created for this customer, with the ability to filter by status (pending, approved, converted, etc.) and/or service(s). Add, edit, delete and view/download estimates as needed.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-communication',
    title: 'Communication',
    intro: `<p>The Communication tab will hold all of the manual, automated and drafted emails for this customer. You can filter by date and email type (manual, automated, draft, etc.) and see whether the email has been opened by the recipient or not. Click on any email to see a copy of the exact email sent or click Send Email to send a new email to this customer.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-files',
    title: 'Files',
    intro: `<p>The Files tab will hold all of the Files that have been saved or uploaded for this customer. Proof of Service photos will automatically save to the files tab whenever they are uploaded to the jobs via mobile app.</p>
      <p>
      When a new estimate or contract is created for the customer, a PDF version will automatically be saved to their Files for easy access to download. Add and delete files as needed.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-editcustomer',
    title: 'Edit Customer',
    intro: `<p>Click Edit Customer to edit their contact, billing or service location information.</p>`,
    position: 'bottom'
  }
];
export const SENT_DRAFT_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Sent/Drafts Page',
    intro: `<p>With the CRM feature, all draft emails and previously sent manual & automated emails will be listed in the Sent/Drafts section.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-sentemail',
    title: 'Sent Email',
    intro: `<p>Use the Sent tab to see a full list of all previously sent emails to your customers. You will see the recipient(s), subject, body content preview and date/time sent.</p>
      <p>Look for checkmarks to the left of the recipient’s name – 1 check means the email has been sent successfully, 2 checks means the recipient has opened the email.</p>`,
    position: 'right'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-filters-search-tut',
    title: 'Filters and Search',
    intro: `<p>Use the date & drop-down filters to narrow down your list to either just manually sent emails, automated emails or all emails. You can also search for a specific email by customer name, email subject or email body.</p>`,
    position: 'bottom'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-drafts',
    title: 'Drafts',
    intro: `<p>The Drafts tab will hold all of your emails you chose to save for later as a draft. Click on the email to continue editing and sending or delete any drafts that are no longer needed.</p>`,
    position: 'right'
  }
];
export const AUTOMATION_SETUP_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Automation Setup Page',
    intro: `<p>Automations allow you to set up automated email schedules to send important job-related information to your customers without having to manually send each email.</p>
      <p>Set up emails to automatically send when jobs are Scheduled, Completed, Reschedule, Skipped and/or Cancelled along with Job Reminders to avoid missed appointments.</p>
      <p>You can customize the service(s) & time to send for each automation and utilize Templates for even easier setup.</p>
      <p><b>Note</b>: Each service can only be assigned to each automation type once. For example, Mowing can only be assigned to one Reminder, one Scheduled, one Completion, etc. automation.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-filters-tut',
    title: 'Filters',
    intro: `<p>Utilize the Job Event,Job Services & Status filters to narrow down your list of Automations.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-add',
    title: 'Add',
    intro: `<p>Click Add to create & setup a new Automation.</p>`,
    position: 'bottom'
  }
];
export const TEMPLATES_TOUR = [
  {
    element: hasBreakpointOccured ? undefined : '.js-page-tut',
    title: 'Templates Page',
    intro: `<p>Templates are a great way to save repetitive email content that can be reused as many times as needed when sending emails. You can personalize the Templates with customer and job information, images, clickable buttons, social media links and various text formatting to tailor the content to your recipients.</p>
      <p>Templates can be used when sending manual emails and when setting up Automated emails. If you make any changes to the email content once a Template is applied, you will have the option to save as a new template instead of editing your existing one.</p>`,
    position: 'auto'
  },
  {
    element: hasBreakpointOccured ? undefined : '.js-addtemplate',
    title: 'Add Template',
    intro: `<p>Click Add Template to create and design a new email Template.</p>`,
    position: 'bottom'
  }
];

export const WEEK_DAYS = [
  {
    value: 'Sunday',
    label: 'Sunday'
  },
  {
    value: 'Monday',
    label: 'Monday'
  },
  {
    value: 'Tuesday',
    label: 'Tuesday'
  },
  {
    value: 'Wednesday',
    label: 'Wednesday'
  },
  {
    value: 'Thursday',
    label: 'Thursday'
  },
  {
    value: 'Friday',
    label: 'Friday'
  },
  {
    value: 'Saturday',
    label: 'Saturday'
  }
];

export const WEEK_ARRAY = [
  {
    value: 1,
    label: 'Sunday'
  },
  {
    value: 2,
    label: 'Monday'
  },
  {
    value: 3,
    label: 'Tuesday'
  },
  {
    value: 4,
    label: 'Wednesday'
  },
  {
    value: 5,
    label: 'Thursday'
  },
  {
    value: 6,
    label: 'Friday'
  },
  {
    value: 7,
    label: 'Saturday'
  }
];

export const JOB_ON_WEEKEND = 'Job(s) scheduled on weekend. Select week to display the jobs.';

//constant being exported to track the back button action in customer create/edit and select forms
export const DETAILS = 'details';
export const LOCATION = 'location';
export const COORDINATE_MISSING = `Looks like this address isn't in our system. Click Cancel and use the "Street" field to search for an address, or click Confirm to save without location features including Geofencing, tracking equipment runtime on jobs, and auto-starting jobs.`;

/*--------------------------------------------------------- */
export const billingFrequencies = [
  {
    label: 'Weekly',
    value: 'weekly'
  },
  {
    label: 'Biweekly',
    value: 'biweekly'
  },
  {
    label: 'Monthly',
    value: 'monthly'
  },
  {
    label: 'Quarterly',
    value: 'quarterly'
  },
  {
    label: 'Invoice on Job Completion',
    value: 'jobCompletion'
  }
];

export const CUSTOMER = '0';
export const LEAD = '1';
export const LEADTOCUSTOMER = '2';

export const JOB_TYPE = { regular: 'Regular', onDemand: 'OnDemand' };

/*----------------------Calendar Views----------------------------------- */
export const WEEK = 'timeGridWeek';
export const MONTH = 'dayGridMonth';
export const DAY = 'timeGridDay';
export const THREE_DAYS = 'threeDays';
export const WORK_WEEK = 'work_week';

/*----------------------Recurring Job Change----------------------------------- */
export const THIS_JOB_ONLY = 1;
export const THIS_COMPLETE_SERIES = 3;
export const THIS_AND_FUTURE_JOBS = 2;
/*-------------------------Delete Messages------------------------------ */
export const CUSTOMER_CANNOT_DELETE_BUT_DEACTIVATE =
  'Completed job(s) exist under this customer and therefore it cannot be deleted. By continuing with Delete,customer will be set to Inactive, not Deleted. All active contracts will be terminated and any non-completed jobs will be deleted.';
/*---------------------------Job Statuses------------------------------ */
export const COMPLETED = 'Completed';
export const SENT_FOR_INVOICING = 'Sent for Invoicing';
export const READY_FOR_INVOICING = 'Ready for Invoicing';
export const SENT_TO_CUSTOMER = 'Sent to Customer';
export const UNSCHEDULED = 'Unscheduled';
export const SCHEDULED = 'Scheduled';
export const STARTED = 'Started';
export const SKIPPED = 'Skipped';
export const ARCHIVED = 'Archived';
export const RESCHEDULED = 'Reschedule';
export const PAUSED = 'Paused';
export const JOB_STATUS = {
  UNSCHEDULED: 1,
  SCHEDULED: 2,
  STARTED: 3,
  COMPLETED: 4,
  SKIPPED: 5,
  RESCHEDULED: 6,
  PAUSED: 7,
  SENT_FOR_INVOICING: 8,
  READY_FOR_INVOICING: 9,
  ARCHIVED: 10,
  SENT_TO_CUSTOMER: 11
};

export const JOB_STATUS_VARIABLE_KEYS = {
  [UNSCHEDULED]: 1,
  [SCHEDULED]: 2,
  [STARTED]: 3,
  [COMPLETED]: 4,
  [SKIPPED]: 5,
  [RESCHEDULED]: 6,
  [PAUSED]: 7,
  [SENT_FOR_INVOICING]: 8,
  [READY_FOR_INVOICING]: 9,
  [ARCHIVED]: 10,
  [SENT_TO_CUSTOMER]: 11
};

export const JOB_STATUS_IDS = {
  1: 'Unscheduled',
  2: 'Scheduled',
  3: 'Started',
  4: 'Completed',
  5: 'Skipped',
  6: 'Rescheduled',
  7: 'Paused',
  8: 'Sent for Invoicing',
  9: 'Ready for Invoicing',
  10: 'Archived',
  11: 'Sent to Customer'
};

export const JOB_STATUSES = [
  {
    label: 'Unscheduled',
    value: JOB_STATUS.UNSCHEDULED
  },
  {
    label: 'Scheduled',
    value: JOB_STATUS.SCHEDULED
  },
  {
    label: 'Started',
    value: JOB_STATUS.STARTED
  },
  {
    label: 'Completed',
    value: JOB_STATUS.COMPLETED
  },
  {
    label: 'Reschedule',
    value: JOB_STATUS.RESCHEDULED
  },
  {
    label: 'Paused',
    value: JOB_STATUS.PAUSED
  },
  {
    label: 'Sent For Invoicing',
    value: 8
  },
  {
    label: 'Ready For Invoicing',
    value: 9
  },
  {
    label: 'Archived',
    value: 10
  }
];

export const RJT_STATUS = {
  Unscheduled: 0,
  PartiallyScheduled: 1,
  CompletelyScheduled: 2
};

export const JOB_INOVICE_STATUS = {
  PENDING: 0,
  SENT_FOR_INVOICING: 1,
  PAID: 2,

  // Info: These are extra statuses
  SYNC_PENDING: 'Paid (Sync-Pending)'
};

export const FREQUENCIES = {
  NO_FREQUENCY: 0,
  DNR: 1,
  CUSTOM: 7,
  MONTHLY: 8
};

export const getFrequencyOption = (freq: number) => {
  if (freq === null || freq === undefined) {
    return FREQUENCIES_LIST[0];
  }

  return FREQUENCIES_LIST.find(frequency => frequency.value === freq);
};

export const FREQUENCIES_LIST = [
  {
    value: 0,
    label: 'No Frequency'
    // Frequency: 0
  },
  {
    value: 1,
    label: 'Do Not Repeat',
    Frequency: 0
  },
  {
    value: 2,
    label: 'Daily',
    Frequency: 1
  },
  {
    value: 3,
    label: 'Weekly',
    Frequency: 7
  },
  {
    value: 4,
    label: 'Every two weeks',
    Frequency: 14
  },
  {
    value: 5,
    label: 'Every three weeks',
    Frequency: 21
  },
  {
    value: 6,
    label: 'Every four weeks',
    Frequency: 28
  },
  {
    value: 8,
    label: 'Monthly',
    Frequency: 30
  },
  {
    value: 7,
    label: 'Custom',
    Frequency: 0
  }
];

export const FREQUENCIES_STRING = {
  DAILY: 'Daily',
  CUSTOM: 'Custom'
};

/*------------------- Tutorial section constants ---------------------*/
export const EMPLOYEES_CREWS = 'employees_crews';
export const EQUIPMENT_DEVICES = 'equipments_devices';
export const MAINTENANCE_SETUP = 'maintenance_setup';
export const CUSTOMERS_JOBS = 'customers_jobs';
export const SCHEDULE = 'schedule';
export const TRACKING = 'tracking';
export const QUICKBOOKS = 'quickbooks';
export const ESTIMATES = 'estimates';
export const ANALYTICS = 'analytics';
export const ROUTES_ODJS = 'routes_odjs';
export const BUDGETING = 'budgeting';
export const BUDGETING_EXPENSE = 'budgeting_expense';
export const BUDGETING_OVERHEAD = 'budgeting_overhead';
export const BUDGETING_WORKHOURS = 'budgeting_workhours';
export const TIMESHEET_REPORT = 'timesheet_report';
export const EMPLOYEE_TIMESHEET = 'employee_timesheet';
export const JOB_REPORTING = 'job_reporting';
export const CUSTOMERS = 'customers_list';
export const CUSTOMER_DETAILS = 'customer_data';
export const SENT_DRAFT = 'sent_draft';
export const AUTOMATION_SETUP = 'automation_setup';
export const TEMPLATES = 'templates';
export const INVOICE = 'online_payment';

/*------------------- Tutorial section IDs ---------------------*/
export const EMPLOYEES_CREWS_SECTION_ID = 1;
export const EQUIPMENT_DEVICES_SECTION_ID = 2;
export const CUSTOMERS_JOBS_SECTION_ID = 3;
export const SCHEDULE_SECTION_ID = 4;
export const TRACKING_SECTION_ID = 5;
export const QUICKBOOKS_SECTION_ID = 7;
export const ESTIMATES_SECTION_ID = 8;
export const ANALYTICS_SECTION_ID = 9;
export const ROUTES_ODJS_SECTION_ID = 10;
export const BUDGETING_SECTION_ID = 12;
export const BUDGETING_EXPENSE_SECTION_ID = 13;
export const BUDGETING_OVERHEAD_SECTION_ID = 14;
export const BUDGETING_WORKHOURS_SECTION_ID = 15;
export const TIMESHEET_REPORT_SECTION_ID = 18;
export const EMPLOYEE_TIMESHEET_SECTION_ID = 19;
export const JOB_REPORTING_SECTION_ID = 20;
export const CUSTOMERS_SECTION_ID = 21;
export const CUSTOMER_DETAILS_SECTION_ID = 22;
export const SENT_DRAFT_SECTION_ID = 23;
export const AUTOMATION_SETUP_SECTION_ID = 24;
export const TEMPLATES_SECTION_ID = 25;
export const INVOICE_SECTION_ID = 26;
export const MAINTENANCE_SECTION_ID = 28;

/*---------------------------Event Types------------------------------ */
export const eventTypes = [
  {
    label: 'IGON',
    value: 'IGON'
  },
  {
    label: 'IGOFF',
    value: 'IGOFF'
  },
  {
    label: 'RUNNING',
    value: 'RUNNING'
  },
  {
    label: 'TOWING START',
    value: 'TOWING_START'
  },
  {
    label: 'TOWING STOP',
    value: 'TOWING_STOP'
  },
  {
    label: 'TOWING AWAY_REPORTING',
    value: 'TOW_AWAY_REPORTING'
  },
  {
    label: 'START',
    value: 'START'
  },
  {
    label: 'STOP',
    value: 'STOP'
  },
  {
    label: 'PRIOD',
    value: 'PRIOD'
  }
];
export const bucketTypes = [
  {
    label: 'ONSITE WORKING',
    value: 'ONSITE_WORKING'
  },
  {
    label: 'OFFSITE WORKING',
    value: 'OFFSITE_WORKING'
  },
  {
    label: 'ONSITE UNKOWN',
    value: 'ONSITE_UNKOWN'
  },
  {
    label: 'DRIVING',
    value: 'DRIVING'
  },
  {
    label: 'OFFSITE UNKOWN',
    value: 'OFFSITE_UNKOWN'
  },
  {
    label: 'ONSITE',
    value: 'ONSITE'
  },
  {
    label: 'OFFSITE',
    value: 'OFFSITE'
  }
];
/*---------------------------Route Type------------------------------ */
export const ROUTE_INSTANCE = 'ROUTE_INSTANCE';
export const ROUTE_TEMPLATE = 'ROUTE_TEMPLATE';
/*---------------------------Event Card Source----------------------------- */
export const CALENDAR = 'calendar';
export const MAP = 'map';
export const MAP_TRACKING = 'map-tracking';
/*---------------------------Severity------------------------------ */
export const severityList = {
  0: 'Low',
  1: 'Medium',
  2: 'High'
};
/*---------------------------Subscription Status------------------------------ */

export const subscriptionStatusIds = {
  1: 'Not Subscribed',
  2: 'Under Free Trial',
  3: 'Subscribed',
  4: 'Under Grace Period',
  5: 'Unsubscribed',
  7: 'Canceled',
  11: 'Canceled' //statusId 11, is auto-cancelled but for display we show 'canceled' only.
};

// subscription status
export const CANCELLED_SUBSCRIPTION = 7;
export const CANCELLATION_PENDING = 13;

export const UNSUBSCRIBED = 5;
export const NOTSUBSCRIBED = 1;
export const SUBSCRIBED = 3;
export const CANCELLED_AUTOCANCELLATION = 11; // When the platform subscription is cancelled
/*--------------------------- GTM EVENTS------------------------------ */
export const GTM_OTPSUBMIT = 'GTM_OTPSUBMIT';
export const GTM_SIGNUP = 'GTM_SIGNUP';
export const GTM_CHECKOUT = 'GTM_CHECKOUT';
export const GTM_CHECKOUT_SUBSCRIPTION = 'GTM_CHECKOUT_SUBSCRIPTION';
export const GTM_DEVICE_CHECKOUT = 'GTM_DEVICE_CHECKOUT';

/*--------------------------- Employee Timecard Status ------------------------------ */

export const timeCardStatuses = {
  clockIn: 0,
  clockOut: 1,
  lunch: 2,
  break: 3
};
export const SELECT_EVENT_TYPE = 'selectEventType';
export const CLOCK_IN = 'clockIn';
export const CLOCK_OUT = 'clockOut';
export const SELECT_BREAK_TYPE = 'selectBreakType';
export const BREAK_END = 'work';
export const BREAK_START = 'break';
export const LUNCH_START = 'lunch';
/*--------------------------- TimesheetStatus------------------------------ */

export const timesheetStatuses = {
  0: 'inProgress',
  1: 'pending',
  2: 'submitted',
  3: 'approved',
  4: 'In Quickbooks'
};
/*--------------------------- SECTIONS ------------------------------ */
export const EMPLOYEES_SECTION = 'Employee';
export const EQUIPMENT_SECTION = 'Equipment';
export const CUSTOMERS_SECTION = 'Customer';
export const SCHEDULE_SECTION = 'Schedule';
export const TRACKING_SECTION = 'Tracking';
export const INVOICES_SECTION = 'Invoice';
export const QUICKBOOKS_SECTION = 'Quickbooks';
export const ESTIMATES_SECTION = 'Estimates';
export const ANALYTICS_SECTION = 'Analytics';
export const ANALYTICS_DASHBOARD_SECTION = 'AnalyticsDashboard';
export const ROUTES_SECTION = 'Routes';
export const BUDGETING_SECTION = 'BudgetAndExpense';
export const TIMESHEET_SECTION = 'Timesheets';
export const JOB_REPORTING_SECTION = 'JobReporting';
export const ROUTE_OPTIMIZATION_SECTION = 'RouteOptimization';

/*--------------------------- LEFT SIDE NAVBAR EXPANDABLE SECTIONS ------------------------------ */

export const EMAIL_SECTION = 'Email';
export const SCHEDULING_SECTION = 'Scheduling';
export const FINANCES_SECTION = 'Finances';

//-----Route optimisation based on these constants------//
export const SHORTER_DISTANCE = 'shorterDistance';
export const SHORTER_DRIVE_TIME = 'shorterDriveTime';

/* ----------------------------------- CRM ---------------------------------- */
export const CRM_ACCESS = 'CRM';

/* ------------------------------ Time and Materials ---------------------------------- */
export const TIME_AND_MATERIALS_ACCESS = 'TimeAndMaterials';

// ------------------------ONE TIME POPUPS------------------------------------------
export const ONE_TIME_POPUPS = {
  INVOICE_RESTRICTION: 'InvoiceRestriction'
};
/* ----------------------------------- Using commonmodal as source ---------------------------------- */

export const COMMON_MODAL = 'commonModal';
/* ----------------------------------- DELETE MODAL ---------------------------------- */
export const CONFIRM = 'Confirm';
export const CONTINUE = 'Continue';
export const REMOVE = 'Remove';
export const GO_BACK = 'Go Back';

/* ----------------------------------- PLAN Names ---------------------------------- */
export enum PLAN_NAME {
  ESSENTIAL = 'PlanA',
  CONNECT = 'PlanF',
  BASIC = 'PlanH',
  PREMIUM = 'PlanB',
  UNLIMITED = 'PlanC'
}

export const PLAN_OPTIONS = Object.entries(PLAN_NAME)
  .map(([key, value]) => ({
    label: capitalize(key),
    value: value
  }))
  .filter(option => option.value !== PLAN_NAME.CONNECT);

/* ------------------------------- PROMO CODES ------------------------------ */
export const PROMO_CODES = {
  PLAN_ID_ZERO: 0
};

/* ----------------------------------- Contract Statuses ---------------------------------- */
export const CONTRACT_STATUS = {
  ACTIVE: 1,
  TERMINATED: -1,
  EXPIRED: -2
};

export const REGISTERED_TRADEMARK = '®';
export const TRADEMARK = '™';
export const COPYRIGHT = '©';
/* ----------------------------- Smart Equipment ---------------------------- */

export const SMART_EQUIPMENT_BATTERY_THRESHOLD = {
  // 40 and above is high
  // 25 to 39 is medium
  // 24 and below is low
  high: 100,
  medium: 39,
  low: 24
};

/* ---------------------------------- ROLES --------------------------------- */
export const ROLES = {
  admin: { key: 'admin', value: 1 },
  operator: { key: 'operator', value: 2 },
  employee: { key: 'employee', value: 3 }
};

export const INVOICE_STATUS_STRINGS = {
  OVERDUE: 'Overdue',
  PAID: 'Paid',
  QUICKBOOKS: `Quickbooks${REGISTERED_TRADEMARK}`,
  REQUESTED: 'Requested',
  PENDING: 'Pending'
};

export const INVOICE_PAYMENT_METHODS = {
  QB: 0,
  EVO: 1
};

export const CALENDAR_VIEWS = {
  DAY: 'timeGridDay',
  THREE_DAYS: 'threeDays',
  WORK_WEEK: 'work_week',
  WEEK: 'timeGridWeek',
  MONTH: 'dayGridMonth'
};

export const CUSTOM_FREQUENCY_TYPES = {
  DAY: 0,
  WEEK: 1
};

/* ---------------------------------- Maintenance --------------------------------- */

export const MAINTENANCE_CADENCE = {
  Recurring: 'recurring',
  OneTime: 'one_time'
};

export const MAINTENANCE_CADENCE_SCHEDULE_TYPES = {
  1: 'Daily',
  2: 'Weekly',
  3: 'Monthly',
  4: 'Yearly',
  5: 'Days',
  6: 'Hours',
  7: 'Miles'
};

export const NORMAL_EQUIPMENT = 'equipment';
export const MATERIALS = 'material';

export const SMART_EQUIPMENT = 'smart';

export const VEHICLE = 'vehicle';

export const STATUS_CHARGING = 'Charging';

export const USER_ROLES = {
  Admin: 1
};

export const PASSWORD_ERR_MSG =
  'Password must be at least 8 characters and contain at least one letter, one number and one special character.';
export const ADMIN_LOGIN_INTO_TIMECLOCK_MSG =
  'No employee record found for the entered Email Address. Please create an employee to login.';
export const OPERATOR_WITHOUT_EMPLOYEE_OBJ_MSG =
  'Please update the operator/employee record to login';
export const TORO_HQ_COORDINATES = { lat: 44.8572504, lng: -93.2871696 };

export const ADD_ON_NAMES = {
  TIME_AND_MATERIALS: 'Time & Materials'
};

/* ----------------------------- Constant Utils ----------------------------- */
/**
 * Retrieves the label corresponding to a given value from the constants list.
 * @returns {string|null} The label if found, otherwise `null`.
 */
export const getConstantByValue = <T extends GenericLabelValue>(
  constants: T[],
  value: number
): string | null => constants.find(item => item.value === value)?.label || null;

/**
 * Retrieves the value corresponding to a given label from the constants list.
 * @returns {number|null} The numeric value if found, otherwise null.
 */
export const getConstantByLabel = <T extends GenericLabelValue>(
  constants: T[],
  label: string
): number | null => constants.find(item => item.label === label)?.value || null;
